export default __webpack_public_path__ + "static/media/Gotham-Light.59aa4004.otf";